import script from "./Tooltip.vue?vue&type=script&setup=true&lang=ts"
export * from "./Tooltip.vue?vue&type=script&setup=true&lang=ts"

import "./Tooltip.vue?vue&type=style&index=0&id=b82732e8&lang=scss"

const __exports__ = script;

export default __exports__